const COLORS = ['#12a594', '#3e63dd', '#f76808', '#e5484d', '#f5d90a'];
const PIECE_COUNT = 54;
const CLEANUP_DELAY_MS = 2400;

export function showConfetti() {
  if (
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ||
    !document.body
  ) {
    return;
  }

  const container = document.createElement('div');
  container.setAttribute('aria-hidden', 'true');
  container.style.cssText = `
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    position: fixed;
    z-index: 10000;
  `;

  document.body.appendChild(container);

  for (let index = 0; index < PIECE_COUNT; index += 1) {
    const piece = document.createElement('span');
    const left = 18 + Math.random() * 64;
    const size = 6 + Math.random() * 8;
    const drift = (Math.random() - 0.5) * 360;
    const drop = 72 + Math.random() * 28;
    const delay = Math.random() * 220;
    const duration = 1400 + Math.random() * 700;
    const rotation = 180 + Math.random() * 720;

    piece.style.cssText = `
      background: ${COLORS[index % COLORS.length]};
      border-radius: ${Math.random() > 0.5 ? '999px' : '2px'};
      height: ${size * 1.4}px;
      left: ${left}vw;
      opacity: 0;
      position: absolute;
      top: -20px;
      transform: translate3d(0, 0, 0) rotate(0deg);
      width: ${size}px;
      will-change: transform, opacity;
    `;

    container.appendChild(piece);

    piece.animate(
      [
        { opacity: 0, transform: 'translate3d(0, 0, 0) rotate(0deg)' },
        { opacity: 1, offset: 0.12 },
        {
          opacity: 1,
          transform: `translate3d(${drift * 0.4}px, ${drop * 0.45}vh, 0) rotate(${rotation * 0.55}deg)`,
        },
        {
          opacity: 0,
          transform: `translate3d(${drift}px, ${drop}vh, 0) rotate(${rotation}deg)`,
        },
      ],
      {
        delay,
        duration,
        easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
        fill: 'forwards',
      }
    );
  }

  window.setTimeout(() => container.remove(), CLEANUP_DELAY_MS);
}
